const scenarios = [
  {
    icon: "ri-store-2-line",
    color: "bg-blue-50 border-blue-100",
    iconColor: "text-blue-600 bg-blue-100",
    industry: "商超大卖场",
    title: "精准选址降低新店失败率",
    kpi: "选址成功率 +62%",
    desc: "某全国连锁超市进入新城市前，通过人口热力与业态构成模型筛选候选地址，新开门店年销售额均值提升43%，亏损店比例从31%降至8%。",
  },
  {
    icon: "ri-restaurant-line",
    color: "bg-orange-50 border-orange-100",
    iconColor: "text-orange-600 bg-orange-100",
    industry: "餐饮连锁",
    title: "客群画像驱动精准拓店",
    kpi: "首月盈利率 +41%",
    desc: "某火锅连锁品牌在全国扩张中，利用客群画像与竞品分析模块锁定目标商圈，新开门店首月客单量超预期38%，竞品侵蚀风险显著降低。",
  },
  {
    icon: "ri-shopping-bag-2-line",
    color: "bg-emerald-50 border-emerald-100",
    iconColor: "text-emerald-600 bg-emerald-100",
    industry: "零售品牌",
    title: "商业活力指数识别潜力商圈",
    kpi: "坪效提升 +38%",
    desc: "某服装零售品牌借助商业活力与交通指数评估，将原定选址更换至活力指数更高的街区，开业首年坪效超过行业均值38%，口碑销售双丰收。",
  },
  {
    icon: "ri-cup-line",
    color: "bg-amber-50 border-amber-100",
    iconColor: "text-amber-600 bg-amber-100",
    industry: "茶饮咖啡",
    title: "竞品分析发现差异化机会",
    kpi: "竞争压力降低 55%",
    desc: "某茶饮品牌利用竞品分布与市场空白分析，在同城竞争激烈区域发现3处高人流低竞争黄金地段，新点位平均日单量较旧选址高出2.1倍。",
  },
];

export default function BAScenarios() {
  return (
    <section className="py-20 px-8" style={{ background: "#f4fbf7" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-emerald-600 tracking-widest uppercase mb-2 block">Industry Scenarios</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">行业应用场景</h2>
          <p className="text-slate-500 text-sm">商超、餐饮、零售等行业的真实选址实践</p>
        </div>
        <div className="grid grid-cols-2 gap-6">
          {scenarios.map((s) => (
            <div key={s.title} className={`rounded-2xl p-6 border ${s.color} hover:shadow-sm transition-all cursor-pointer`}>
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${s.iconColor}`}>
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-slate-400 font-medium">{s.industry}</span>
                    <span className="text-xs bg-emerald-100 text-emerald-700 font-semibold px-2 py-0.5 rounded-full">{s.kpi}</span>
                  </div>
                  <h3 className="text-slate-800 font-semibold text-base mb-2">{s.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
